<template>
    <div>
        <b-button variant="default" @click="$bvModal.show(modalId)">
            <font-awesome-icon :icon="['fas', 'right-left']" />
            Convert Reservation
        </b-button>
        <modal
            title="Convert PayPal Pending Reservation"
            :id="modalId"
            @ok="convertPaypal"
            >Are you sure you want to convert reservation {{ params.data.id }}?
        </modal>
    </div>
</template>

<script>
import API from '../../../../api';
import Modal from '../../../generic/modal/modal.vue';
import { ADMIN_CHANNEL_ERRORS_PAYPAL_CONVERT } from '../../../../endpoints';
export default {
    components: {
        Modal,
    },
    data() {
        return {
            modalId: null,
        };
    },
    mounted() {
        this.modalId = this.params?.data?.id.toString();
    },
    methods: {
        async convertPaypal() {
            try {
                await API.post(
                    ADMIN_CHANNEL_ERRORS_PAYPAL_CONVERT(this.params.data.id)
                );
                this.params.refresh();
                this.successToast({
                    text: 'Reservation successfully converted.',
                });
            } catch (e) {
                this.errorToast({
                    text:
                        e.response?.data?.message ||
                        'Could not convert reservation',
                });
            }
        },
    },
};
</script>
